export enum ActionTypes {
  SAVE_AUFTRAG = 'SAVE_AUFTRAG_BY_MATCHCODE',
  UPDATE_AUFTRAG = 'UPDATE_AUFTRAG',
  COPY_AUFTRAG = 'COPY_AUFTRAG',
  GET_ADRESSEN = 'GET_ADRESSEN',
  GET_ADRESSE_BY_ID = 'GET_ADRESSE_BY_ID',
  GET_ADRESSEN_BY_NAME_OR_MATCHCODE = 'GET_ADRESSEN_BY_NAME_OR_MATCHCODE',
  IMPORT_ADRESSEN = 'IMPORT_ADRESSEN',
  SEARCH_LAENDER = 'SEARCH_LAENDER',
  GET_LAENDER = 'GET_LAENDER',
  GET_DYNAMIC_AUFTRAG_SERVICES = 'GET_DYNAMIC_AUFTRAG_SERVICES', //#84367
  GET_AUFTRAG_SERVICES = 'GET_AUFTRAG_SERVICES', //#84367
  SET_AUFTRAG_SERVICES = 'SET_AUFTRAG_SERVICES', //#84367
  GET_MANDANTEN_BY_HAUPTMANDANT = 'GET_MANDANTEN_BY_HAUPTMANDANT',
  GET_HAUPTMANDANTEN = 'GET_HAUPTMANDANTEN',
  GET_CURRENTUNTERMANDANTEN = 'GET_CURRENTUNTERMANDANTEN',
  GET_FREIEMANDANTEN = 'GET_FREIEMANDANTEN',
  ADRIMPORTMANDANT = 'ADRIMPORTMANDANT',
  UPDATE_MANDANT = 'UPDATE_MANDANT',
  UPDATE_UNTERMANDANT = 'UPDATE_UNTERMANDANT',
  GET_ANZEIGESTATI = 'GET_ANZEIGESTATI',
  GET_CURRENTSENDUNGSSTATI = 'GET_CURRENTSENDUNGSSTATI',
  GET_FREIESENDUNGSSTATI = 'GET_FREIESENDUNGSSTATI',
  CREATE_ANZEIGESTATUS = 'CREATE_ANZEIGESTATUS',
  DELETE_ANZEIGESTATUS = 'DELETE_ANZEIGESTATUS',
  UPDATE_ANZEIGESTATUS = 'UPDATE_ANZEIGESTATUS',
  UPDATE_SENDUNGSSTATUS = 'UPDATE_SENDUNGSSTATUS',
  GET_SENDUNGSSTATUS = 'GET_SENDUNGSSTATUS',
  GET_ORTE = 'GET_ORTE',
  SEARCH_ORTE = 'SEARCH_ORTE',
  ADD_NOTIFICATIONS = 'ADD_NOTIFICATIONS',
  ADD_NOTIFICATION = 'ADD_NOTIFICATION',
  REMOVE_NOTIFICATIONS = 'REMOVE_NOTIFICATIONS',
  REMOVE_NOTIFICATION = 'REMOVE_NOTIFICATION',
  RESET_AUFTRAGSERFASSUNG = 'RESET_AUFTRAGSERFASSUNG',
  SET_AUFTRAG_ID = 'SET_AUFTRAG_ID',
  RESET_ADRESSERFASSUNG = 'RESET_ADRESSERFASSUNG',
  SET_ADRESSE_ID = 'SET_ADRESSE_ID',
  SET_ADRESSE_KOPIE_ID = 'SET_ADRESSE_KOPIE_ID',
  COPY_ADRESSE = 'COPY_ADRESSE',
  SAVE_ADRESSE = 'SAVE_ADRESSE',
  DELETE_ADRESSE = 'DELETE_ADRESSE',
  DELETE_AUFTRAG = 'DELETE_AUFTRAG',
  RELOAD_ADRESSMANAGEMENT = 'RELOAD_ADRESSMANAGEMENT',
  SET_ADRESSE_FIELD = 'SET_ADRESSE_FIELD',
  SET_AUFTRAG_KOPIE_ID = 'SET_AUFTRAG_KOPIE_ID',
  SET_ABWEICHENDE_BELADUNG = 'SET_ABWEICHENDE_BELADUNG',
  GET_ABWEICHENDE_BELADUNG = 'GET_ABWEICHENDE_BELADUNG',
  GET_IS_ABWEICHENDE_BELADEADRESSE = 'GET_IS_ABWEICHENDE_BELADEADRESSE',
  SET_IS_ABWEICHENDE_BELADEADRESSE = 'SET_IS_ABWEICHENDE_BELADEADRESSE',
  SET_IS_NEUTRALER_ABSENDER_SET = 'SET_IS_NEUTRALER_ABSENDER',
  SET_BELADEDATUM = 'SET_BELADEDATUM',
  SET_BELADEZEIT_VON = 'SET_BELADEZEIT_VON',
  SET_BELADEZEIT_BIS = 'SET_BELADEZEIT_BIS',
  SET_EMPFAENGERREFERENZ = 'SET_EMPFAENGERREFERENZ',
  SET_ENTLADEDATUM = 'SET_ENTLADEDATUM',
  SET_ENTLADEZEIT_VON = 'SET_ENTLADEZEIT_VON',
  SET_ENTLADEZEIT_BIS = 'SET_ENTLADEZEIT_BIS',
  SET_ABSENDERREFERENZ = 'SET_ABSENDERREFERENZ',
  SET_CURRENT_SERVICES = 'SET_CURRENT_SERVICES',
  SET_CURRENT_CONTROLLING = 'SET_CURRENT_CONTROLLING',
  SET_CURRENT_SENDUNGSPOSITIONEN = 'SET_CURRENT_SENDUNGSPOSITIONEN',
  SET_CURRENT_AUFTRAGPOS = 'SET_CURRENT_AUFTRAGPOS',
  SET_CURRENT_MANDANT = 'SET_CURRENT_MANDANT',
  SET_CURRENT_ZUSLADEMITTEL = 'SET_CURRENT_ZUSLADEMITTEL',
  UPDATE_ZUR_UEBERTRAGUNG_MARKIEREN = 'UPDATE_ZUR_UEBERTRAGUNG_MARKIEREN',
  UPDATE_ZUR_TYPUEBERTRAGUNG_MARKIEREN = 'UPDATE_ZUR_TYPUEBERTRAGUNG_MARKIEREN',
  UPDATE_TYP = 'UPDATE_TYP',
  UPDATE_RESET_STATI = 'UPDATE_RESET_STATI',
  GET_DEFAULT_SERVICES = 'GET_DEFAULT_SERVICES',
  CLEAR_SUCHVORSCHLAEGE = 'CLEAR_SUCHVORSCHLAEGE',
  GET_FAHRZEUGE = 'GET_FAHRZEUGE',
  GET_AUFTRAEGE = 'GET_AUFTRAEGE',
  GET_AUFTRAG = 'GET_AUFTRAG',
  GET_LADEMITTEL = 'GET_LADEMITTEL',
  GET_VERPACKUNGEN = 'GET_VERPACKUNGEN',
  SET_ACTIVE_TAB = 'SET_ACTIVE_TAB',
  GET_ACTIVE_TAB = 'GET_ACTIVE_TAB',
  GET_AUFTRAG_ID = 'GET_AUFTRAG_ID',
  GET_WAEHRUNGEN = 'GET_WAEHRUNGEN',
  SET_WAEHRUNGEN = 'SET_WAEHRUNGEN',
  GET_EIGENTUEMER = 'GET_EIGENTUEMER',
  SET_MIT_GEFAHRGUETERN = 'SET_MIT_GEFAHRGUETERN',
  SET_TERMINKENNZEICHEN = 'SET_TERMINKENNZEICHEN',
  GET_TERMINKENNZEICHEN = 'GET_TERMINKENNZEICHEN',
  SET_ZUSTELLKENNZEICHEN = 'SET_ZUSTELLKENNZEICHEN',
  GET_ZUSTELLKENNZEICHEN = 'GET_ZUSTELLKENNZEICHEN',
  SET_ANLIEFERKENNZEICHEN = 'SET_ANLIEFERKENNZEICHEN',
  GET_ANLIEFERKENNZEICHEN = 'GET_ANLIEFERKENNZEICHEN',
  SET_CURRENT_ZUSTELLKENNZEICHEN = 'SET_CURRENT_ZUSTELLKENNZEICHEN',
  SET_CURRENT_ANLIEFERKENNZEICHEN = 'SET_CURRENT_ANLIEFERKENNZEICHEN',
  GET_BENUTZER_BY_ID = 'GET_BENUTZER_BY_ID',
  RELOAD_AUFTRAGSRESEARCH = 'RELOAD_AUFTRAGSRESEARCH',
  GET_REPORTS = 'GET_REPORTS',
  GET_ENCRYPTED_IDS = 'GET_ENCRYPTED_IDS',
  SET_ADRESSE = 'SET_ADRESSE',
  GET_SPRACHEN = 'GET_SPRACHEN',
  SAVE_BENUTZER = 'SAVE_BENUTZER',
  UPDATE_BENUTZER = 'UPDATE_BENUTZER',
  RESET_BENUTZERERFASSUNG = 'RESET_BENUTZERERFASSUNG',
  SET_BENUTZER = 'SET_BENUTZER',
  GET_BENUTZERLISTE = 'GET_BENUTZERLISTE',
  RELOAD_USERMANAGEMENT = 'RELOAD_USERMANAGEMENT',
  SET_FRANKATUR = 'SET_FRANKATUR',
  GET_FRANKATUREN = 'GET_FRANKATUREN',
  SET_VERKEHRSART = 'SET_VERKEHRSART',
  GET_VERKEHRSARTEN = 'GET_VERKEHRSARTEN',
  SET_AUTHENTICATION = 'SET_AUTHENTICATION',
  SET_CONFIRM_REGISTRY = 'SET_CONFIRM_REGISTRY',
  SET_IBAN = 'SET_IBAN',
  SET_BIC = 'SET_BIC',
  SET_NACHNAHMEBETRAG = 'SET_NACHNAHMEBETRAG',
  SET_NACHNAHMEBETRAG_WAEHRUNG = 'SET_NACHNAHMEBETRAG_WAEHRUNG',
  USERNAME_EXISTS = 'USERNAME_EXISTS',
  SET_TAUSCH_A = 'SET_TAUSCH_A',
  SET_TAUSCH_B = 'SET_TAUSCH_B',
  SET_TAUSCH_R = 'SET_TAUSCH_R',
  SET_TAUSCH_Y = 'SET_TAUSCH_Y',
  SET_MODAL_CONFIG = 'SET_MODAL_CONFIG',
  SET_CURRENT_AUFTRAGSGEFAHRGUETER = 'SET_CURRENT_AUFTRAGSGEFAHRGUETER',
  SEARCH_VERPACKUNGEN = 'SEARCH_VERPACKUNGEN',
  SEARCH_GEFAHRGUTKLASSEN = 'SEARCH_GEFAHRGUTKLASSEN',
  SEARCH_GEFAHRGUTKLASSEN_UNNR = 'SEARCH_GEFAHRGUTKLASSEN_UNNR',
  SET_GEFAHRGUTKLASSE_UNNR = 'SET_GEFAHRGUTKLASSE_UNNR',
  SET_METROKENNUNG = 'SET_METROKENNUNG',
  GET_METROKENNUNGEN = 'GET_METROKENNUNGEN',
  SET_SPERRIGKEIT = 'SET_SPERRIGKEIT',
  GET_SPERRIGKEITEN = 'GET_SPERRIGKEITEN',
  IMPORT_PREMIUM = 'IMPORT_PREMIUM',
  FETCH_TRANSLATIONS = 'FETCH_TRANSLATIONS',
  GET_TRANSLATION = 'GET_TRANSLATION',
  GET_DEFAULTSTATUSKETTE = 'GET_DEFAULTSTATUSKETTE',
  SET_DEFAULTSTATUSKETTE = 'SET_DEFAULTSTATUSKETTE',
  GET_ALL_STATI = 'GET_ALL_STATI',
  GET_LAENDER_REG = 'GET_LAENDER_REG',
  GET_LAENDER_MAUT = 'GET_LAENDER_MAUT',
  GET_MAUT = 'GET_MAUT',
  ANFRAGE_GESTARTET = 'ANFRAGE_GESTARTET',
  GET_ORTE_REG = 'GET_ORTE_REG',
  SET_HINWEIS = 'SET_HINWEIS',
  SET_DISPOHINWEIS = 'SET_DISPOHINWEIS',
  SET_ZOLLVERMERK = 'SET_ZOLLVERMERK',
  SET_AUFTRAG_FIELD = 'SET_AUFTRAG_FIELD',
  SET_AUFTRAGRESEARCH_FIELD = 'SET_AUFTRAGRESEARCH_FIELD',
  SET_FROM_AND_TO_DATE = 'SET_FROM_AND_TO_DATE',
  SET_AUFTRAEGE_SORT_BY = 'SET_AUFTRAEGE_SORT_BY',
  SEARCH_AUFTRAGSVORLAGE = 'SEARCH_AUFTRAGSVORLAGE',
  RELOAD_AUFTRAGSVORLAGE_MANAGEMENT = 'RELOAD_AUFTRAGSVORLAGE_MANAGEMENT',
  SET_VORLAGE_AUFTRAG_ID = 'SET_VORLAGE_AUFTRAG_ID',
  GET_ABSENDERADRESSE_BY_MANDANT = 'GET_ABSENDERADRESSE_BY_MANDANT',
  LOADING = 'LOADING',
  RESET_AUFTRAGSVORLAGEERFASSUNG = 'RESET_AUFTRAGSVORLAGEERFASSUNG',
  SET_AUFTRAGSVORLAGEERFASSUNG_FIELD = 'SET_AUFTRAGSVORLAGEERFASSUNG_FIELD',
  SAVE_AUFTRAGSVORLAGE = 'SAVE_AUFTRAGSVORLAGE',
  VORLAGE_NAME_EXISTS = 'VORLAGE_NAME_EXISTS',
  SERVERLOG = 'SERVERLOG',
  SWITCH_TO_SEARCH = 'SWITCH_TO_SEARCH',
  SET_NOTIFICATION_FIELD = 'SET_NOTIFICATION_FIELD',
  UPDATE_INDEX = 'UPDATE_INDEX',
  SET_CLIENT_CONFIG = 'SET_CLIENT_CONFIG',
  SET_CURRENT_MANDANT_ID = 'SET_CURRENT_MANDANT_ID',
  SET_ROWSINGRID = 'SET_ROWSINGRID',
  RESET_MODAL_CONFIG = 'RESET_MODAL_CONFIG',
  SESSIONCOUNT = 'SESSIONCOUNT',
  COUNT_AUFTRAEGE = 'COUNT_AUFTRAEGE',
  CSVEXPORT = 'CSVEXPORT',
  GET_BERECHNTEILE = 'GET_BERECHNTEILE',
  SET_CONFIG_PARAM_FIELD = 'SET_CONFIG_PARAM_FIELD',
  SET_TOTALSEARCHRESULTS = 'SET_TOTALSEARCHRESULTS',
  SET_SPOTPREISNR = 'SET_SPOTPREISNR',
  SET_DOKUMENTENVERWEIS = 'SET_DOKUMENTENVERWEIS',
  RESET_CLIENT_CONFIG = 'RESET_CLIENT_CONFIG',
  SET_INITIALIZED = 'SET_INITIALIZED',
  SET_CLIENT_CONFIG_MODEL = 'SET_CLIENT_CONFIG_MODEL',
  SET_ERFASSER = 'SET_ERFASSER',
  SET_AENDERER = 'SET_AENDERER',
  SET_CURRENT_BENUTZER = 'SET_CURRENT_BENUTZER',
  GET_CURRENT_BENUTZER = 'GET_CURRENT_BENUTZER',
  SET_DATUM_GEANDERT = ' SET_DATUM_GEANDERT',
}

export interface ReduxAction {
  type: ActionTypes;
  payload?: any;
}
